import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useHistory, useParams, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { Button, Col, Empty, Layout, Row, Select } from 'antd';

import { useQuery } from '../../hooks/useQuery';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearModel,
  getModelById,
  getModelPrimitives,
  getModelSeries,
} from '../../data/store/instruments/instrumentsActions';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
// import { SortArrow } from '../Clients/ClientSummary';

import { textSort } from '../../helpers/textSort';
import { monthList } from '../../constants/monthList';
import { ReactComponent as Edit } from './img/edit-icon.svg';
import { ReactComponent as Cross } from '../../assets/cross-btn-icon.svg';

import './style.scss';
import CustomSortIconBig from '../../components/CustomSortIconBig/CustomSortIconBig';

const { Header } = Layout;
const ModelItemView = () => {
  const { t, i18n } = useTranslation('');
  const history = useHistory();
  const dispatch = useDispatch();
  const { search, pathname, state } = useLocation();
  const query = useQuery(search);
  const { itemKey } = useParams();

  const [primitivesType, setPrimitivesType] = useState('1');
  const [primitivesSet, setPrimitivesSet] = useState(null);
  const [redirectFrom, setRedirectFrom] = useState('current');

  const meanReturnOptions = [
    { value: '1', label: t('MEAN_LINEAR_RETURN') },
    // { value: '2', label: t('MEAN_LOG_RETURN') },
    // { value: '3', label: t('VARIANCE') },
    { value: '4', label: t('STANDARD_DEV_VOLATILITY') },
    { value: '61', label: t('WEIGHT_RANGE_VOLATILITY_ADJUSTMENT') },
  ];

  const { assets, assetCategories, diversificationList } = useSelector(
    (state) => state.instrumentsReducer,
  );
  const model = useSelector((state) => state.instrumentsReducer.modelById);
  const primitives = useSelector(
    (state) => state.instrumentsReducer.primitives,
  );
  const modelSeries = useSelector(
    (state) => state.instrumentsReducer.modelSeries,
  );

  const [series, setSeries] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [assetSelectOptions, setAssetSelectOptions] = useState(null);

  const [sortOrder, setSort] = useState(null);
  const [sortOrderValue, setSortOrderValue] = useState(null);

  const language = i18n.languages?.length ? i18n.languages[0] : 'en';
  const currentLang = ['en', 'sw'].includes(language) ? language : 'en';

  const tab = query.get('tab');
  const asset = query.get('asset');
  const primitive = query.get('primitive');

  useEffect(() => {
    if (itemKey) {
      setRedirectFrom(state?.tabs ?? 'current');
      dispatch(getModelById(itemKey));
      !tab && history.replace(`${pathname}?tab=index-series`);
    }
    return () => dispatch(clearModel());
  }, [itemKey]);

  useEffect(() => {
    if (asset && assetSelectOptions) {
      setSelectedOptions(+asset);
    } else if (!asset && assetSelectOptions && selectedOptions === null) {
      const assetSort = assetSelectOptions.sort((a, b) =>
        textSort(a.name, b.name, 1),
      );
      const firstAsset = assetSort ? assetSort[0]?.id || 0 : 0;
      history.replace(`?tab=index-series&asset=${firstAsset}`);
    }
  }, [asset, assetSelectOptions]);

  //TODO not mock
  useEffect(() => {
    setSort(null);
    if (primitive) {
      const data = primitives?.filter((i) => i.entity === +primitive);
      setPrimitivesSet(data);
      setPrimitivesType(primitive);
    } else if (!primitive && tab === 'model-primitives') {
      history.push('?tab=model-primitives&primitive=1');
    }
  }, [primitives, primitive, tab]);

  useEffect(() => {
    if (assets) {
      const options = assets
        ?.filter((i) => !i?.is_virtual)
        .map((i) => {
          const data = {
            id: i.ID,
            name: i.name,
            status: getStatusAsset(i.ID),
          };
          return data;
        });
      setAssetSelectOptions(options);
    }
  }, [assets, series]);

  useEffect(() => {
    if (modelSeries?.series) {
      setSeries(modelSeries.series);
    }
    if (!modelSeries?.series && model?.series_set_id) {
      dispatch(getModelPrimitives(itemKey));
      dispatch(
        getModelSeries({ id: itemKey, seriesSetId: model.series_set_id }),
      );
    }
  }, [model, modelSeries]);

  const getStatusAsset = useCallback(
    (id) => {
      if (series?.length) {
        const assetDataForValidate = series.find(
          (i) => i.asset_class_id === id,
        );
        if (!assetDataForValidate) {
          return 'blank';
        }
        const result = [];

        assetDataForValidate?.values?.forEach((i) => {
          const array = Object.values(i.data);
          result.push(...array.filter((i) => i !== null));
        });

        return result.every((i) => !!i || i === 0)
          ? 'full'
          : result.every((i) => i === '')
            ? 'blank'
            : 'partially';
      }
      return 'blank';
    },
    [series],
  );

  const handlePrimitivesType = (value) => {
    history.push(`?tab=${tab}&primitive=${value}`);
  };

  const getAssetById = (id) => {
    const asset = assets.find((asset) => asset.ID === id);
    if (asset) {
      return {
        name: asset?.name ?? '',
        category: asset?.financialAssetCategory.name ?? '',
      };
    }
    const cateegory = assetCategories.find((asset) => asset.ID === id);
    if (cateegory) {
      return {
        name: cateegory?.name ?? '',
        category: '',
      };
    }
    const iversification = diversificationList.find((asset) => asset.id === id);
    if (iversification) {
      return {
        name: iversification?.name ?? '',
        category: '',
      };
    }
  };

  useEffect(() => {
    if (sortOrder && primitivesSet) {
      setSortOrderValue(null);
      const direction = sortOrder === 'ascend' ? 1 : -1;
      const sortSet = [...primitivesSet].sort((a, b) =>
        textSort(
          getAssetById(a.asset_class_1_id)?.name,
          getAssetById(b.asset_class_1_id)?.name,
          direction,
        ),
      );
      setPrimitivesSet(sortSet);
    }
  }, [sortOrder]);

  useEffect(() => {
    if (sortOrderValue && primitivesSet) {
      setSort(null);
      const sortSet = [...primitivesSet].sort((a, b) =>
        sortOrderValue === 'ascend' ? a.value - b.value : b.value - a.value,
      );
      setPrimitivesSet(sortSet);
    }
  }, [sortOrderValue]);

  const handleEditModel = () => {
    history.push(`/quant/model/item/${itemKey}`);
  };

  const handleChangeTab = (path) => {
    history.push(`${pathname}?tab=${path}`);
  };

  const handleChangeAssets = (value) => {
    history.push(`?tab=${tab}&asset=${value}`);
  };

  const handleReset = () => {
    history.replace(`/quant/model/list?tabs=${redirectFrom}`);
  };

  return (
    <div className="instrument-wrapper" style={{ position: 'relative' }}>
      <div>
        <Header className="headerStyle">
          <Row className="overview-tabs-wrapper">
            <Col className="tabs-tab-wrapper" span={18}>
              <h1 className="suggested-portfolios-title">
                {t('MODEL')}{' '}
                <span className="model-name-title">
                  {model?.name ?? 'not found'}
                </span>
              </h1>
            </Col>
          </Row>
          <div className="top-btn-wrapper">
            <Button
              type="text"
              icon={<Cross />}
              iconPosition="end"
              className="portfolio-cancel-btn"
              onClick={handleReset}
            >
              {t('CANCEL')}
            </Button>
            <Button
              type="text"
              className="portfolio-cancel-btn"
              icon={<Edit />}
              iconPosition="end"
              onClick={handleEditModel}
            >
              {t('EDIT')}
            </Button>
          </div>
        </Header>
        <h2
          style={{ marginTop: '30px' }}
          className="suggested-portfolios-title"
        >
          {' '}
          {t('MODEL')} {model?.name ?? 'not found'}
        </h2>

        <Row
          justify={'space-between'}
          align={'center'}
          className="model-tabs-wrapper"
        >
          <Col className="model-tabs-column">
            <div
              onClick={() => handleChangeTab('index-series')}
              className={`model-tab-btn-wrapper ${tab === 'index-series' ? 'selected' : ''}`}
            >
              <p className="model-tab-btn-title">{t('INDEX_SERIES')}</p>
            </div>
          </Col>
          <Col className="model-tabs-column">
            <div
              onClick={() => handleChangeTab('model-primitives')}
              className={`model-tab-btn-wrapper ${tab === 'model-primitives' ? 'selected' : ''}`}
            >
              <p className="model-tab-btn-title">{t('MODEL_PRIMITIVES')}</p>
            </div>
          </Col>
        </Row>
        <div>
          {tab === 'index-series' ? (
            <>
              <Row justify={'start'} style={{ padding: '24px' }}>
                <CustomSelect
                  animate={false}
                  placeholder={t('SELECT_ASSET_CLASS')}
                  className="custom-select asset-select-models"
                  onChange={(value) => handleChangeAssets(value)}
                  value={selectedOptions}
                >
                  {assetSelectOptions
                    ?.slice()
                    ?.sort((a, b) => textSort(a.name, b.name, 1))
                    .map((item) => {
                      return (
                        <Select.Option key={item.id} value={item.id}>
                          <div
                            className={`asset-option-status ${item.status}`}
                          />
                          <div className="">{item.name}</div>
                        </Select.Option>
                      );
                    })}
                </CustomSelect>
              </Row>
              <Row justify={'space-between'} className="model-series-headers">
                <Col className="model-series-headers-cell"> </Col>
                {monthList[currentLang].map((i) => (
                  <Col key={i} className="model-series-headers-cell">
                    {i}
                  </Col>
                ))}
              </Row>
              {series &&
                series
                  ?.find((i) => i.asset_class_id === selectedOptions)
                  ?.values.map((i, index) => {
                    return (
                      <Row
                        key={i.year}
                        className={`model-series-row ${index % 2 !== 0 && 'is-odd'}`}
                      >
                        <Col className="model-series-row-cell">{i.year}</Col>
                        {Object.keys(i.data).map((month) => (
                          <Col key={month} className={'model-series-row-cell'}>
                            {i.data[month] !== null ? (
                              <span className="series-data-cell">
                                {i.data[month].toFixed(2)}
                              </span>
                            ) : null}
                          </Col>
                        ))}
                      </Row>
                    );
                  })}
            </>
          ) : (
            <>
              <div className="primitives-tabs-wrapper">
                {meanReturnOptions.map((i) => (
                  <div
                    key={i.value}
                    className={`primitives-tabs-item ${i.value === primitivesType ? 'active' : ''}`}
                    onClick={() => handlePrimitivesType(i.value)}
                  >
                    {t(i.label)}
                  </div>
                ))}
              </div>
              <Row wrap={false} className="primitives-header">
                <Col
                  span={primitivesType === '61' ? 9 : 12}
                  className="primitives-title-class contrast"
                  style={{ displey: 'flex', gap: '8px' }}
                >
                  {t('ASSET_CLASS')}
                  <CustomSortIconBig sortOrder={sortOrder} setSort={setSort} />
                </Col>
                {primitivesType === '61' ? (
                  <>
                    <Col span={5} className="primitives-title-value">
                      {t('p1')}
                    </Col>
                    <Col span={5} className="primitives-title-value">
                      {t('p2')}
                    </Col>
                    <Col span={5} className="primitives-title-value">
                      {t('VALUE')}
                    </Col>
                  </>
                ) : (
                  <>
                    <Col
                      span={12}
                      className="primitives-header-value"
                      style={{ displey: 'flex', gap: '8px' }}
                    >
                      {t('QUANT_VALUE')}
                      <CustomSortIconBig
                        sortOrder={sortOrderValue}
                        setSort={setSortOrderValue}
                      />
                    </Col>
                  </>
                )}
              </Row>
              {primitivesSet?.length ? (
                primitivesSet?.map((el, index) => {
                  return (
                    <Row
                      key={uuidv4()}
                      wrap={false}
                      className={`primitives-row ${index % 2 === 0 ? '' : 'is-odd'}`}
                    >
                      <Col
                        span={primitivesType === '61' ? 9 : 12}
                        className="primitives-title-class contrast"
                      >
                        <div className="">
                          <p className="primitives-cell-name">
                            {getAssetById(el.asset_class_1_id)?.name}
                          </p>
                          <p className="primitives-cell-category">
                            {getAssetById(el.asset_class_1_id)?.category}
                          </p>
                        </div>
                      </Col>
                      {primitivesType === '61' ? (
                        <>
                          <Col
                            span={5}
                            style={{ marginLeft: '-12px' }}
                            className="primitives-title-value"
                          >
                            <div className="">{(el?.p1 * 100)?.toFixed(2)}</div>
                          </Col>
                          <Col
                            span={5}
                            style={{ marginLeft: '-6px' }}
                            className="primitives-title-value"
                          >
                            <div className="">{(el?.p2 * 100)?.toFixed(2)}</div>
                          </Col>
                          <Col
                            span={5}
                            style={{ marginLeft: '-8px' }}
                            className="primitives-title-value"
                          >
                            <div className="">
                              {(el?.value * 100)?.toFixed(2)}
                            </div>
                          </Col>
                        </>
                      ) : primitivesType !== '61' ? (
                        <>
                          <Col span={12} className="primitives-heaer-value">
                            <div className="">
                              {((el?.value + el?.adjustment) * 100)?.toFixed(2)}
                            </div>
                          </Col>
                        </>
                      ) : null}
                    </Row>
                  );
                })
              ) : (
                <>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModelItemView;
